import each from 'lodash/each';

import logger from '../../utils/logger';
import config from 'config';

class GoogleAdwords {
  async _init(state, commit, id) {
    if (!state.currentIds.googleAdwords.includes(id)) {
      // no need to load any scripts for google adwords because
      // the gtag script is already loaded from google analytics

      id = id.indexOf('AW-') === 0 ? id : `AW-${id}`;

      gtag('config', id, { send_page_view: false });

      commit('trackId', { property: 'googleAdwords', value: id });

      logger.log(`${id} initialize.`);
    } else {
      logger.log(`${id} already initialized.`);
    }
  }

  _pageView(state, commit, send_to, ecomm_pagetype, ecomm_prodid, type) {
    send_to = send_to.indexOf('AW-') === 0 ? send_to : `AW-${send_to}`;

    let payload = {
      send_to,
      ecomm_prodid,
      ecomm_pagetype,
    };

    gtag('event', 'page_view', payload);

    logger.log(`${type ? `${type} `:''}page view event with payload:`);

    logger.log(payload);
  }

  _purchase(state, commit, send_to, value, type) {
    send_to = send_to.indexOf('AW-') === 0 ? send_to : `AW-${send_to}`;

    let payload = {
      send_to,
      currency: 'USD',
      transaction_id: `${state.order.order_lookup_number}`,
      value,
    };

    gtag('event', 'conversion', payload);

    logger.log(`${type ? `${type} `:''}purchase event with payload:`);

    logger.log(payload);
  }

  viewPage({ state, commit }) {
    logger.groupCollapsed('VS Google Adwords');

    this._init(state, commit, config.G_ADS_ID);

    this._pageView(state, commit, config.G_ADS_ID);

    logger.groupEnd();
  }

  vsViewSales({ state, commit }) {
    logger.groupCollapsed('VS Google Adwords');

    if (logger.checkRetargeting(state.campaign.tracking.global.disable_vs_retargeting)) {
      this._init(state, commit, config.G_ADS_ID);

      this._pageView(state, commit, config.G_ADS_ID, 'product', state.campaign.analytics_cid);
    }

    logger.groupEnd();
  }

  vsViewThankYou({ state, commit }) {
    logger.groupCollapsed('VS Google Adwords');

    if (logger.checkRetargeting(state.order.tracking[state.order.orders[0].analytics_cid].global.disable_vs_retargeting)) {
      this._init(state, commit, config.G_ADS_ID);

      let value = state.order.sale_total + state.order.shipping_discount_total - state.order.shipping_total - state.order.tax_total;

      this._pageView(state, commit, config.G_ADS_ID, 'purchase');

      this._purchase(state, commit, `${config.G_ADS_ID}/${config.G_ADS_CONVERSION_LABEL}`, Math.round(value * 100) / 100);
    }

    logger.groupEnd();
  }

  vsRegister({ state, commit }) {
    logger.groupCollapsed('VS Google Adwords');

    this._init(state, commit, config.G_ADS_ID);

    let send_to = `${config.G_ADS_ID/config.G_ADS_CONVERSION_LABEL_REGISTER}`;

    send_to = send_to.indexOf('AW-') === 0 ? send_to : `AW-${send_to}`;

    gtag('event', 'conversion', { send_to });

    logger.log(`${config.G_ADS_ID}/${config.G_ADS_CONVERSION_LABEL_REGISTER} register event.`);

    logger.groupEnd();
  }

  clientViewSales({ state, commit }) {
    logger.groupCollapsed('Client Google Adwords');

    let adwordsGlobal = state.campaign.tracking.global.google,
      adwordsCampaign = state.campaign.tracking.campaign.google;

    if (logger.checkCampaign(adwordsCampaign.id)) {
      this._init(state, commit, adwordsCampaign.id);

      this._pageView(state, commit, adwordsCampaign.id, 'product', state.campaign.slug, 'Campaign Specific');
    }

    if (logger.checkGlobal(adwordsGlobal.id, adwordsCampaign.id)) {
      this._init(state, commit, adwordsGlobal.id);

      this._pageView(state, commit, adwordsGlobal.id, 'product', state.campaign.slug, 'Global');
    }

    logger.groupEnd();
  }

  clientViewThankYou({ state, commit }) {
    logger.groupCollapsed('Client Google Adwords');

    each(state.order.orders, order => {
      logger.groupCollapsed(order.campaign_name);

      let adwordsGlobal = state.order.tracking[order.analytics_cid].global.google,
        adwordsCampaign = state.order.tracking[order.analytics_cid].campaign.google,
        value = order.sale_total + order.shipping_discount - order.shipping_total - order.tax_total;

      if (logger.checkCampaign(adwordsCampaign.id)) {
        this._init(state, commit, adwordsCampaign.id);

        this._pageView(state, commit, adwordsCampaign.id, 'purchase');

        this._purchase(state, commit, `${adwordsCampaign.id}/${adwordsCampaign.label}`, Math.round(value * 100) / 100, 'Campaign Specific');
      }

      if (logger.checkGlobal(adwordsGlobal.id, adwordsCampaign.id)) {
        this._init(state, commit, adwordsGlobal.id);

        this._pageView(state, commit, adwordsGlobal.id, 'purchase');

        this._purchase(state, commit, `${adwordsGlobal.id}/${adwordsGlobal.label}`, Math.round(value * 100) / 100, 'Global');
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }
};

export default new GoogleAdwords();